import React from "react"
import { formatFileSize } from "../../utils/formatting"

export const BASKET_HEADER = `Корзина загрузки`

export const BASKET_ISDOWNLOADING = `Ваша корзина уже скачивается`

export const BASKET_NULL_TITLE = `Твоя корзина пуста`

export const BASKET_NULL_CONTENT = `Когда ты добавишь какой-то мод в корзину, он появится здесь`

export const BUTTON_ALL_LOAD = `Скачать`

export const MOD_VERSION = (modVersion) => {
    return <React.Fragment>Версия мода: {modVersion}</React.Fragment>
}

export const TITLE_ALL_SIZE = (allSizes) => {
    return <React.Fragment>Объем загружаемых модов: {formatFileSize(allSizes)} из 500 МБ</React.Fragment>
}